import { render, staticRenderFns } from "./GroupsMobile.vue?vue&type=template&id=fd2315fa&scoped=true&"
import script from "./GroupsMobile.vue?vue&type=script&lang=js&"
export * from "./GroupsMobile.vue?vue&type=script&lang=js&"
import style0 from "./GroupsMobile.vue?vue&type=style&index=0&id=fd2315fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2315fa",
  null
  
)

export default component.exports